// extracted by mini-css-extract-plugin
export default {"customBg":"Layout_customBg__PFtUY"};